// extracted by mini-css-extract-plugin
export default {"TagContainer":"Tag_TagContainer__5vSXV","Tag":"Tag_Tag__Xftmg","Loading":"Tag_Loading__esbXl","load":"Tag_load__nhRQE"};